/** Hợp đồng adapter: biến proposal chuẩn của engine thành payload lưu của trang (API hiện có). */
import type { AiProposal, AiProposalItem } from '@/types/ai-agent';

export interface DiffRow {
  ref: string;
  op: AiProposalItem['op'];
  sectionLabel: string;
  before: string;
  after: string;
  /** HTML đã sanitize từ BE (chiến lược / kết quả B3) */
  htmlAfter?: string;
  rationale: string;
  /** Có thể sửa nội dung `after` trước khi áp dụng */
  editable: boolean;
  warning?: string;
}

export interface ApplyResult {
  savedIds: string[];
  saveEndpoint: string;
  /** Lưu lại trạng thái trước khi áp dụng (cùng API) */
  undo: () => Promise<void>;
}

export interface StepAdapter<Cur = unknown> {
  /** Khoá sub-step engine, vd. "b2.swot" */
  key: string;
  title: string;
  /** Dữ liệu mới nhất từ API của trang */
  load: () => Promise<Cur>;
  buildSnapshot: (cur: Cur) => Record<string, unknown>;
  /** Kết quả các bước trước (đọc bằng quyền người dùng) */
  buildContext?: () => Promise<Record<string, unknown>>;
  diff: (proposal: AiProposal, cur: Cur) => DiffRow[];
  /** Tải lại dữ liệu, gộp các mục đã chọn (kèm nội dung đã sửa), lưu qua API cũ */
  apply: (proposal: AiProposal, selectedRefs: string[], edits: Record<string, string>) => Promise<ApplyResult>;
}

export class AdapterSaveError extends Error {}

/** Adapter của các trang khác nhau có kiểu dữ liệu trang khác nhau; UI chỉ chuyển tiếp dữ liệu đó. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyStepAdapter = StepAdapter<any>;
